import React from 'react';
import Question from '../Question';
import { useWorkAndConnections } from '../data';
const Connection = () => {
	const { connections } = useWorkAndConnections();
	return (
		<section className='contact bg-main mt-20'>
			<div className='container flex flex-col md:flex-row gap-8'>
				<Question />

				<div className='address mb-16 md:mb-0 md:mt-16 flex flex-col gap-6'>
					{connections.map((e, index) => (
						<div
							className='flex gap-4'
							key={index}>
							<div className='image text-white border-2 border-secondary bg-white flex items-center justify-center w-20 h-20 p-4 relative rounded-md'>
								<img
									loading='lazy'
									src={e.Image}
									alt=''
								/>
							</div>
							<div className='data flex flex-col'>
								<p className='text-white font-bold text-xl'>{e.title}</p>
								<p className='text-white'>{e.data1}</p>
								<p className='text-white'>{e.data2}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Connection;
